/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Balancing_Display_Max_OpeningInputs */



/**
* | output |
* | --- |
* | "Opening" |
*
* @param {Manual_Balancing_Display_Max_OpeningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_display_max_opening = /** @type {((inputs?: Manual_Balancing_Display_Max_OpeningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_Display_Max_OpeningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Opening")
	return /** @type {LocalizedString} */ ("Ouverture")
});